import BaseSyncManager from './BaseSyncManager';

export default class UnitSyncManager extends BaseSyncManager {
  // Inherits all methods from BaseSyncManager
}
